import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47716 6.47716 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7.00781C12.4142 7.00781 12.75 7.3436 12.75 7.75781V11.2505H16.2426C16.6568 11.2505 16.9926 11.5863 16.9926 12.0005C16.9926 12.4147 16.6568 12.7505 16.2426 12.7505H12.75V16.2431C12.75 16.6573 12.4142 16.9931 12 16.9931C11.5858 16.9931 11.25 16.6573 11.25 16.2431V12.7505H7.75736C7.34315 12.7505 7.00736 12.4147 7.00736 12.0005C7.00736 11.5863 7.34315 11.2505 7.75736 11.2505H11.25V7.75781C11.25 7.3436 11.5858 7.00781 12 7.00781Z"
  })));
};

export { SvgPlusCircle as ReactComponent };
//# sourceMappingURL=plus-circle.svg.js.map
